import Styled, { css } from 'styled-components';

export const Legend = Styled.legend`
  all: unset;
  font-size: 1.4rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 0.5em;
  display: block;

  ${({ theme: { text }}) => css`
    font-size: ${text.formCaptionFontSize && text.formCaptionFontSize};
    font-family: ${text.formCaptionFontFamily && text.formCaptionFontFamily};
  `}
`;

Legend.displayName = 'Legend';

export default Legend;
